// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import SupplierTableStore from '@src/views/PurchaseOrders/store'

const rootReducer = {
  auth,
  navbar,
  layout,
  SupplierTableStore
}

export default rootReducer
